import './style/LinkedCard.css';
import React, { useState, useEffect } from 'react';
import Icon from './Icon';
import Divider from './Divider';
import { Text } from '@harperai/materialize-design-system';

const LinkedCard = ({ children, label, icon, details, first = false, last = false, color = "#000" }) => {
    const [localColor, setLocalColor] = useState(color);

    useEffect(() => {
        if (color === "green") {
            setLocalColor("#00b894");
        }

        if (color === "orange") {
            setLocalColor("#e17055");
        }

        if (color === "gray") {
            setLocalColor("#b9bfd6");
        }

        if (color==="white") {
            setLocalColor("#ffffff");
        }
    }, [color]);
    return (
        <div className="keystone-linked-card product-horizontal-container align-center relative">
            <div className="linked-card-icon-wrapper">
                <Icon icon={icon} size={24} z={2} color={localColor} />
            </div>
            <Divider 
                width={32}
            />
            <div className="keystone-linked-card keystone-card grow-1 product-vertical-container width-100">
                <div className="flex vertical pad-s">
                    {details && (
                        <Text size="title" bold={true}>{details}</Text>
                    )}
                    {label && (
                        <Text size="caption" bold={true} variant="secondary">{label}</Text>
                    )}
                </div>
                {children && <Divider />}
                {children}
            </div>
            <Divider 
                absolute={true}
                vertical={true}
                first={first}
                last={last}
            />
        </div>
    );
};

export default React.memo(LinkedCard);